import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import { FaRegFilePdf } from 'react-icons/fa';
// import ReactGA from 'react-ga';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    fontWeight: 700,
    textAlign: 'center',
    fontSize: 32,
    marginTop: '8vh',
    lineHeight: 'normal'
  }
}));

const Header = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  // const Event = () => {
  //   ReactGA.event({
  //     category: 'Button',
  //     action: 'Pressed DOWNLOAD PDF'
  //   })
  // }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        container
        justify="center"
        style={{ marginTop: '-1%' }}
      >
        <Grid item>
          <Typography className={classes.title}>Online Resume</Typography>
          <div style={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              // href="/docs/curriculum.pdf"
              style={{ marginTop: '4vh', color: "#FCFCFC", background: "#84a086" }}
              startIcon={<FaRegFilePdf />}
              // onClick={Event}
              onClick={() => alert(':( ...My resume is temporarily unavailable. Ask me by email: davibaltarx.npm@gmail.com')}
            >
              Download PDF
            </Button>
          </div>
        </Grid>
      </Grid>
      <div className={classes.content} style={{ background: '#FFF', textAlign: 'center', paddingTop: '8vh', paddingBottom: '5vh' }}>
      <span style={{ color: '#F00', fontSize: 12 }}>:( ...My resume is temporarily unavailable.<br/> Ask me by email: davibaltarx.npm@gmail.com</span>
      </div>
      <hr style={{ borderColor: '#E8E8E8', borderTop: 'none', borderLeft: 'none', borderRight: 'none', paddingTop: '3vh' }} />
    </div>
  );
};


export default Header;
